import { all, call, put, select, takeLatest } from 'redux-saga/effects'

import * as Actions from 'actions/news'
import { NewsPageModules } from 'static/constants'

import * as Selectors from 'selectors'
import { fetchChartData } from 'sagas/charts'
import { withGaioProjectId } from 'utils/gaio'

export function* fetchFilterTimeline({ payload: { dateFrom, dateTo } }) {
  const chart = yield select(Selectors.getFilterTimeline)

  let searchBody = yield select(Selectors.getSearchBody, dateFrom, dateTo)

  if (searchBody.module_name === NewsPageModules.GAIO) {
    const selectedProjectId = yield select(Selectors.getGaioSelectedProjectId)
    searchBody = withGaioProjectId(searchBody, selectedProjectId)
  }

  const { timeline: result } = yield call(fetchChartData, chart, searchBody)

  yield put(Actions.fetchFilterTimelineSuccess(result))
}

export function* watchFetchFilterTimeline() {
  yield takeLatest(Actions.fetchFilterTimelineStart, fetchFilterTimeline)
}

export default function* newsSaga() {
  yield all([
    watchFetchFilterTimeline()
  ])
}
